import type { SupplierDirectoryListItem } from '@tandemone/types'
import { Link } from 'react-router'

import { MobileList } from '@/components/ui/mobile-list'
import { CertificationsCell } from '@/domains/supplier-profile'

import { FavoriteStar } from './favorite-star'
import { FoundingBadge } from './founding-badge'
import { SupplierVerifiedBadge } from './status-badge'

type Props = {
  items: SupplierDirectoryListItem[]
  emptyMessage: string
  rowHref: (item: SupplierDirectoryListItem) => string
  rowLinkState?: unknown
  showFavorite?: boolean
}

export function SupplierDirectoryMobileList({
  items,
  emptyMessage,
  rowHref,
  rowLinkState,
  showFavorite = true
}: Props) {
  return (
    <MobileList isEmpty={items.length === 0} emptyMessage={emptyMessage}>
      {items.map(item => (
        <li key={item.supplierId} className='relative'>
          {/* the star sits outside the link: nesting a button inside an
              anchor is invalid and swallows the tap on touch. */}
          {showFavorite ? (
            <div className='absolute top-2 right-2 z-10'>
              <FavoriteStar
                slug={item.companySlug}
                supplierId={item.supplierId}
                isFavorited={item.isFavorited}
              />
            </div>
          ) : null}
          <Link
            to={rowHref(item)}
            state={rowLinkState}
            className='flex flex-col gap-2 px-4 py-3 pr-16 text-inherit no-underline transition-colors hover:bg-muted/40'
          >
            <div className='flex min-w-0 flex-col leading-tight'>
              {item.isFoundingSupplier ? <FoundingBadge /> : null}
              <p className='text-sm font-medium break-words text-foreground'>
                {item.companyName}
              </p>
              <p className='mt-1 text-xs text-muted-foreground'>
                {`${item.country ?? '—'} · ${item.region ?? '—'}`}
              </p>
            </div>
            <div className='flex flex-wrap items-center gap-1.5'>
              <SupplierVerifiedBadge status={item.status} />
              <CertificationsCell certifications={item.certifications} />
            </div>
          </Link>
        </li>
      ))}
    </MobileList>
  )
}
